/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
export var UtilContext = React.createContext({
    loading: true,
    countries: [],
    industries: [],
    companySizes: [],
    addressTypes: [],
    documentTypes: [],
});
export var UtilProvider = function (_a) {
    var children = _a.children, utilDatasource = _a.utilDatasource;
    var _b = useState([]), countries = _b[0], setCountries = _b[1];
    var _c = useState(true), loadingBankAccountTypes = _c[0], setLoadingBankAccountTypes = _c[1];
    var _d = useState([]), documentTypes = _d[0], setDocumentTypes = _d[1];
    var _e = useState(true), loadingDocumentTypes = _e[0], setLoadingDocumentTypes = _e[1];
    var _f = useState([]), companySizes = _f[0], setCompanySizes = _f[1];
    var _g = useState(true), loadingCompanySizes = _g[0], setLoadingCompanySizes = _g[1];
    var _h = useState([]), addressTypes = _h[0], setAddressTypes = _h[1];
    var _j = useState(true), loadingAddressTypes = _j[0], setLoadingAddressTypes = _j[1];
    var _k = useState([]), industries = _k[0], setIndustries = _k[1];
    var _l = useState(true), loadingIndustries = _l[0], setLoadingIndustries = _l[1];
    var requestCountries = function () {
        setLoadingBankAccountTypes(true);
        utilDatasource
            .getCountries()
            .then(setCountries)
            .finally(function () { return setLoadingBankAccountTypes(false); });
    };
    var requestDocumentTypes = function () {
        setLoadingDocumentTypes(true);
        utilDatasource
            .getDocumentTypes()
            .then(setDocumentTypes)
            .finally(function () { return setLoadingDocumentTypes(false); });
    };
    var requestCompanySizes = function () {
        setLoadingCompanySizes(true);
        utilDatasource
            .getCompanySizes()
            .then(setCompanySizes)
            .finally(function () { return setLoadingCompanySizes(false); });
    };
    var requestIndustries = function () {
        setLoadingIndustries(true);
        utilDatasource
            .getIndustriesTypes()
            .then(setIndustries)
            .finally(function () { return setLoadingIndustries(false); });
    };
    var requestAddressTypes = function () {
        setLoadingAddressTypes(true);
        utilDatasource
            .getAddressTypes()
            .then(setAddressTypes)
            .finally(function () { return setLoadingAddressTypes(false); });
    };
    useEffect(function () {
        requestCountries();
        requestIndustries();
        requestAddressTypes();
        requestCompanySizes();
        requestDocumentTypes();
    }, []);
    return (React.createElement(UtilContext.Provider, { value: {
            loading: loadingBankAccountTypes ||
                loadingDocumentTypes ||
                loadingCompanySizes ||
                loadingAddressTypes ||
                loadingIndustries,
            countries: countries,
            companySizes: companySizes,
            addressTypes: addressTypes,
            industries: industries,
            documentTypes: documentTypes,
        } }, children));
};
